module.exports = __webpack_public_path__ + "65ef1d486f751e54716098e75c850394.pdf";